import { render, staticRenderFns } from "./v-banner.vue?vue&type=template&id=35c5c261&"
import script from "./v-banner.vue?vue&type=script&lang=js&"
export * from "./v-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports